import script from "./Recheck-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./Recheck-popup.vue?vue&type=script&setup=true&lang=js"

import "./Recheck-popup.vue?vue&type=style&index=0&id=2ab98165&scoped=true&lang=scss"
import "./Recheck-popup.vue?vue&type=style&index=1&id=2ab98165&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab98165"]])

export default __exports__